/* =============================================================
   SUPABASE CLIENT
   =============================================================
   One client for the whole app, on the anon key.

   Every read and write is authorised by RLS against the signed-in
   user's company -- public.current_company_id(), from the JWT's
   subject. A service-role key would bypass all of it and ship in
   plain text to every browser, so it never appears here.
   ============================================================= */

import { createClient } from '@supabase/supabase-js'
import { env, isSupabaseConfigured } from '@/config/env'

if (!isSupabaseConfigured) {
  // Loud, immediate, and before any screen renders. See config/env.ts.
  throw new Error(
    'Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY ' +
      '(copy app/.env.example to app/.env.local).',
  )
}

export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // No magic links or OAuth redirects land here, so there is no callback
    // fragment to parse — and leaving it on would make the client try.
    detectSessionInUrl: false,
  },
})
